import { render, staticRenderFns } from "./PartnerIndex.vue?vue&type=template&id=832be15a&scoped=true&"
import script from "./PartnerIndex.vue?vue&type=script&lang=js&"
export * from "./PartnerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832be15a",
  null
  
)

export default component.exports